export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_37_User.a3bc9b2a.svg";